module.exports = __webpack_public_path__ + "img/51-ba6dff.png";